export const validateEmail = (value, t = (key) => key) => {
  const normalizedValue = String(value ?? "").trim();

  if (normalizedValue === "") {
    return { valid: true, error: "" };
  }

  const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedValue);

  return {
    valid: isValid,
    error: isValid ? "" : t("createuser.validation.invalidEmail"),
  };
};

export const validatePhone = (value, t = (key) => key) => {
  const normalizedValue = String(value ?? "").trim();

  if (normalizedValue === "") {
    return { valid: true, error: "" };
  }

  const isValid = /^\+[0-9()\-\s]{6,20}$/.test(normalizedValue);

  return {
    valid: isValid,
    error: isValid ? "" : t("participant.validation.invalidPhone"),
  };
};

export const validateOpeningHours = (value, t = (key) => key) => {
  const normalizedValue = String(value ?? "").trim();

  if (normalizedValue === "") {
    return { valid: true, error: "" };
  }

  const hasValidChars = /^[A-Za-zÀ-ÿ0-9\s:().,/-]+$/.test(normalizedValue);
  const hasLetterDayText = /[A-Za-zÀ-ÿ]{2,}/.test(normalizedValue);
  const hasTimeRange = /(?:[01]?\d|2[0-3])(?::[0-5]\d)?\s*-\s*(?:[01]?\d|2[0-3])(?::[0-5]\d)?/.test(
    normalizedValue,
  );

  const isValid = hasValidChars && hasLetterDayText && hasTimeRange;

  return {
    valid: isValid,
    error: isValid ? "" : t("participant.validation.invalidOpeningHours"),
  };
};
